import { AppBar, Toolbar, Grid, Button, Typography, Box } from "@mui/material";
import { useAuth } from "../../context/AuthContext";

//Renders the header component.
export default function Header({ showLogout, title }) {
  const { logout } = useAuth();

  return (
    <AppBar component="header" aria-label="Global Navigation" position="fixed" sx={{ zIndex: 1200 }}>
      <Toolbar disableGutters={true}>
        <Grid container alignItems="center" wrap="nowrap">

          {/* TxDOT logo */}
          <Grid item xs="auto" sx={{ display: 'flex', paddingLeft: { xs: 1, sm: 3 } }}>
            <Box role="img" aria-label="TxDOT and TTI Logos" sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Box component="img" alt="" src="/images/TxDOTLogo.png" sx={{ width: 'auto', height: { xs: '25px', sm: '40px', md: '55px' }, marginBottom: '6px' }} />
              <Box aria-hidden="true" sx={{
                height: { xs: '30px', sm: '40px', md: '50px' },
                width: '1px',
                backgroundColor: 'white',
                marginLeft: '20px',
                marginRight: '15px',
                marginTop: '8px',
                marginBottom: '2px',
                display: { xs: 'none', sm: 'block' }
              }} />
              <Box component="img" alt="TTI Logo" src="/images/TTILogoWhite.png" sx={{ width: 'auto', height: { xs: '13px', sm: '18px', md: '30px' }, marginTop: { xs: 0, sm: '25px' } }} />
            </Box>
          </Grid>

          {/* Title bar */}
          <Grid item xs sx={{ minWidth: 0, textAlign: 'center' }}>
            <Typography variant="h1"
              sx={{ color: 'primary.light', textTransform: "none", fontSize: { xs: '13px', sm: '16px', md: '22px' }, fontWeight: 'bold', lineHeight: 1.2 }}
            >
              {title}
            </Typography>
          </Grid>

          {/* Add logout button */}
          {showLogout && (
            <Grid item xs="auto" sx={{ paddingRight: 2 }}>
              <Button
                onClick={logout}
                sx={{ color: 'primary.light', textTransform: "none" }}
              >
                Logout
              </Button>
            </Grid>
          )}
        </Grid>
      </Toolbar>
    </AppBar >
  );
}